// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---node-modules-gatsby-theme-apollo-core-src-pages-404-js": () => import("./../../../node_modules/gatsby-theme-apollo-core/src/pages/404.js" /* webpackChunkName: "component---node-modules-gatsby-theme-apollo-core-src-pages-404-js" */),
  "component---node-modules-gatsby-theme-apollo-docs-src-components-template-js": () => import("./../../../node_modules/gatsby-theme-apollo-docs/src/components/template.js" /* webpackChunkName: "component---node-modules-gatsby-theme-apollo-docs-src-components-template-js" */),
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-callback-js": () => import("./../../../src/pages/callback.js" /* webpackChunkName: "component---src-pages-callback-js" */)
}

